<template>
<div>

    <div v-if="loading" class="text-center" style="margin-top: 30px;">
        <i class="fa fa-circle-o-notch fa-spin"></i> Building PDF
    </div>
    <div v-else>
        <vue-headful :title="'Inspection-'+inspectionDateFormatted + '-'+inspection.JobsiteName+' :: MeritEHS'" />

        <div class="container d-print-none">
            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0 d-block d-md-inline-block">
                    <li class="breadcrumb-item font-weight-light d-block d-md-inline-block mt-md-0 mt-2">
                        <router-link :to="`/inspections`">
                            <i class="fa fa-list"></i> Inspections
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light d-block d-md-inline-block mt-md-0 mt-2">
                        <router-link :to="`/inspections/view/${inspection.InspectionId}`">
                            <inspection-name :inspection="inspection" />
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">
                        <i class="fa fa-file-pdf-o"></i> PDF
                    </li>
                </ol>
            </h4>
        </div>
        <div class="container bg-white d-print-none py-4 mb-4">
            <div class="alert alert-info">
                <strong>How to Export as PDF:</strong>
                <ol>
                    <li>On your browser, there should be a "File" or "Options" tab with a "Print" option. You may also hold down the "Ctrl" key and press the "P" key.</li>
                    <li>This will bring up the print page options box. There should be an option called "Select Printer" or "Destination".</li>
                    <li>Select "Save as PDF" or "Adobe PDF".</li>
                    <li>Click "Save" or "Print". This will open your file explorer and let you save it to your computer as a PDF.</li>
                </ol>

                <div>
                    <strong>PDF Settings:</strong>
                    <ol>
                        <li class="mb-1" v-if="pdfLogo">
                            <span>Show/Hide Logo:</span>
                            <select v-model="showLogo">
                                <option :value="true">Show Logo</option>
                                <option :value="false">Hide Logo</option>
                            </select>
                            <span class="small">Show/Hide your company logo on the Inspection PDF report.</span>
                        </li>

                        <li class="mb-1">
                            <span>Show/Hide {{ labelCompliant }}:</span>
                            <select v-model="showCompliant">
                                <option :value="1">Show {{ labelCompliant }}</option>
                                <option :value="0">Hide {{ labelCompliant }}</option>
                            </select>
                            <span class="small">You can hide the {{ labelCompliant }} items if you want to create a {{ labelNonCompliant }} Only PDF.</span>
                        </li>
                        <li class="mb-1" v-if="showCompliant == 1">
                            <span>Show/Hide N/A:</span>
                            <select v-model="showNA">
                                <option :value="1">Show N/A</option>
                                <option :value="0">Hide N/A</option>
                            </select>
                            <span class="small">You can hide the {{ labelNonCompliant }} items if you want to create a {{ labelCompliant }} Only PDF.</span>
                        </li>
                        <li class="mb-1" v-if="enable_insp_scmm == 1">
                            <span>Show/Hide Safety Comittee Sections:</span>
                            <select v-model="showSafetyCommittee">
                                <option :value="1">Show Safety Committee</option>
                                <option :value="0">Hide Safety Committee</option>
                            </select>
                            <span class="small"></span>
                        </li>
                        <li class="mb-1" v-if="custom_field_sections != null && custom_field_sections.length > 0">
                            <span>Show/Hide Custom Fields</span>
                            <select v-model="showCustomFields">
                                <option :value="true">Show Custom Fields</option>
                                <option :value="false">Hide Custom Fields</option>
                            </select>
                            <span class="small">You can hide the Safety Committee, Minues, Options/Questions.</span>
                        </li>
                    </ol>
                </div>
            </div>
        </div>

        <div class="container bg-white py-4">
            <div class="row" v-if="pdfLogo && showLogo === true" style="margin-bottom: 50px;">
                <div class="col-3">
                    <img :src="pdfLogo" class="img-fluid" />
                </div>
            </div>

            <h5>Inspection Details</h5>
            <div class="row">
                <div class="col-6">
                    <div class="row mb-1">
                        <div class="col-4 col-sm-12 text-muted">Jobsite:</div>
                        <div class="col-8 col-sm-12">
                            {{ inspection.JobsiteNumber }} - {{ inspection.JobsiteName }}
                        </div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-4 col-sm-12 text-muted">Jobsite#:</div>
                        <div class="col-8 col-sm-12">{{ inspection.JobsiteNumber }}</div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-4 col-sm-12 text-muted">Superintendent:</div>
                        <div class="col-8 col-sm-12"><user-name :plainText="true" :user="superintendent" /></div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-4 col-sm-12 text-muted"># of Employees On Site:</div>
                        <div class="col-8 col-sm-12">{{ inspection.NumberOfEmployees }}</div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-4 col-sm-12 text-muted">Division:</div>
                        <div class="col-8 col-sm-12">{{ inspection.DivisionName }}</div>
                    </div>
                    <div class="row mb-1 mb-lg-3">
                        <div class="col-4 col-sm-12 text-muted">Equipment:</div>
                        <div class="col-8 col-sm-12" v-if="inspection.equipment_id">{{ inspection.equipment_type_name }} - {{ inspection.model_number }} - {{ inspection.serial_number }}<template v-if="inspection.equipment_name"> - {{ inspection.equipment_name }}</template>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="row mb-1">
                        <div class="col-4 col-sm-12 text-muted">Inspection Date:</div>
                        <div class="col-8 col-sm-12">{{ inspection.InspectionDate | moment("MM/DD/YYYY") }}</div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-4 col-sm-12 text-muted">Inspection Status:</div>
                        <div class="col-8 col-sm-12">
                            <h5 :class="`text-${inspection.status_color}`">{{ inspection.status_name }}</h5>
                        </div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-4 col-sm-12 text-muted">Inspected Form:</div>
                        <div class="col-8 col-sm-12">{{ inspection.form_name }}</div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-4 col-sm-12 text-muted">Inspected By:</div>
                        <div class="col-8 col-sm-12"><user-name :plainText="true" :user="owner" v-if="inspection.hide_creator == 0 || $store.state.user.is_admin" /></div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-4 col-sm-12 text-muted">General Contractor:</div>
                        <div class="col-8 col-sm-12">{{ inspection.GeneralContractor }}</div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-4 col-sm-12 text-muted">Subcontractors Onsite:</div>
                        <div class="col-8 col-sm-12">{{ inspection.subcontractors_onsite }}</div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-4 text-muted">Jobsite Address:</div>
                        <div class="col-8">
                            {{ inspection.JobsiteAddress }} {{ inspection.JobsiteAddress2 }}<br />
                            {{ inspection.JobsiteCity }}, {{ inspection.JobsiteState }} {{ inspection.JobsiteZip }}
                        </div>
                    </div>
                </div>
            </div>
            <hr/>

            <template v-if="personnel.length > 0">
                <h5>Personnel</h5>
                <div class="row">
                    <div class="col-6">
                        <div class="row mb-1" v-for="field in personnel">
                            <div class="col-4 col-sm-12 text-muted">{{ field.field_label }}:</div>
                            <div class="col-8 col-sm-12">
                                <span v-if="field.employee_id">{{ field.employee_first_name }} {{ field.employee_last_name }}</span>
                                <span v-else>{{ field.other_personnel_name }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
            </template>

            <template v-if="enable_insp_scmm == 1 && showSafetyCommittee == 1">
                <h5 class="mt-4">Safety Committee</h5>
                <template v-if="safety_committee_members">
                    <div v-for="member in safety_committee_members">
                        {{ member.name }} | {{ member.craft }} | {{ member.company }}
                    </div>
                </template>
                <template v-else>
                    -- No Safety Committee Meeting Held --
                </template>

                <h5 class="mt-4">Safety Committee Meeting Minutes</h5>
                <template v-if="safety_committee_members">
                    <div class="mb-4">
                        <div class="text-muted">A. Discuss inspection results and status of project Corrective Actions:</div>
                        <div class="">
                            <div v-if="inspection.scmm_status_of_actions" v-html="inspection.scmm_status_of_actions"></div>
                            <div v-else>--</div>
                        </div>
                    </div>
                    <div class="mb-4">
                        <div class="text-muted">B. Project incidents and lessons learned:</div>
                        <div class="">
                            <div v-if="inspection.scmm_lessons_learned" v-html="inspection.scmm_lessons_learned">
                            </div>
                            <div v-else>--</div>
                        </div>
                    </div>
                    <div class="mb-4">
                        <div class="text-muted">C. Safety concerns and suggestions voiced by any other project team member(s):</div>
                        <div class="">
                            <div v-if="inspection.scmm_suggested_safety" v-html="inspection.scmm_suggested_safety">
                            </div>
                            <div v-else>--</div>
                        </div>
                    </div>
                    <div class="mb-4">
                        <div class="text-muted">D. Upcoming safety sensitive activities/tasks:</div>
                        <div class="">
                            <div v-if="inspection.scmm_upcoming_activities" v-html="inspection.scmm_upcoming_activities">
                            </div>
                            <div v-else>--</div>
                        </div>
                    </div>
                    <div class="mb-4">
                        <div class="text-muted">E. Proactive safety measures being utilized throughout the project, and/or individuals who have displayed HSE leadership:</div>
                        <div class="">
                            <div v-if="inspection.scmm_proactive_measures" v-html="inspection.scmm_proactive_measures">
                            </div>
                            <div v-else>--</div>
                        </div>
                    </div>
                    <div class="mb-4">
                        <div class="text-muted">F. Any other relevant topic discussed by the safety committee:</div>
                        <div class="">
                            <div v-if="inspection.scmm_other" v-html="inspection.scmm_other">
                            </div>
                            <div v-else>--</div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    -- No Safety Committee Meeting Held --
                </template>
                <hr/>
            </template>

            <h5 class="mt-4">Summary</h5>
            <ul class="list-group list-group-flush">
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <div class="text-muted">Total {{ labelCompliant }}</div>
                    <div>{{ inspection.TotalCompliant }}</div>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <div class="text-muted">Total {{ labelNonCompliant }}</div>
                    <div>{{ (inspection.TotalInspected - inspection.TotalCompliant) }}</div>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <div class="text-muted">Total Inspected</div>
                    <div>{{ inspection.TotalInspected }}</div>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <div class="text-muted">Score</div>
                    <div>
                        <inspection-score :data="inspection" />
                    </div>
                </li>
            </ul>

            <div v-if="custom_field_sections && custom_field_sections.length > 0 && showCustomFields === true">
                <custom-field-print :sections="custom_field_sections"></custom-field-print>
            </div>

            <h5 class="mt-4">Additional Comments</h5>
            <p v-if="inspection.Comment">{{ inspection.Comment }}</p>
            <p v-else>-- None --</p>
            <hr/>

            <h5 class="mt-4">{{ labelNonCompliant }} Items</h5>
            <template  v-if="sectionNonCompliant.length > 0">
                <div v-for="s in sectionNonCompliant" class="mt-4">
                    <h5><b>{{s['DisplayOrder']}}.0 {{s['SectionName']}}</b></h5>
                    <table class="table table-condensed table-bordered">
                        <tbody>
                            <template v-for="i in s['elements']">
                                <tr :key="'noncompliant-key-'+i.InspectionSectionId+'.'+i.DisplayOrder" class="break-protect">
                                    <td>{{s['DisplayOrder']}}.{{i.DisplayOrder}}</td>
                                    <td>{{ i.ElementText  }}</td>
                                    <td>
                                        <label class="text-success" v-if="i.ComplianceStatusId == 1">{{ labelCompliant }}</label>
                                        <label class="text-danger" v-if="i.ComplianceStatusId == 2">{{ labelNonCompliant }}</label>
                                        <label v-if="i.ComplianceStatusId == 3 || (undefined == i.ComplianceStatusId)">{{ labelNA }}</label>
                                    </td>
                                </tr>
                                <tr v-if="i.Comment" :key="'noncompliant-comment-'+i.InspectionSectionId+'.'+i.DisplayOrder">
                                    <td colspan="3">
                                        <b>Comment:</b> {{ i.Comment }}
                                    </td>
                                </tr>
                                <tr v-for="action in i.actions" v-if="i.ComplianceStatusId == 2 && i.actions.length > 0" :key="'noncompliant-action-'+action.corrective_action_id">
                                    <td colspan="3">
                                        <div class="row mb-1">
                                            <div class="col-6">
                                                <div class="d-print-none mb-1">
                                                    <span class="text-muted d-sm-inline-block d-xs-block">Status:</span>
                                                    <span :class="`text-${action.status_color}`">{{ action.status_name }}</span>
                                                </div>
                                                <div class="d-none d-print-block mb-1">
                                                    <span class="text-muted d-sm-inline-block d-xs-block">Status:</span>
                                                    <span :class="`text-${action.status_color}`">{{ action.status_name }}</span>
                                                </div>
                                                <div class="mb-1">
                                                    <span class="text-muted d-sm-inline-block d-xs-block">Source:</span>
                                                    <span>{{ action.source_name }}</span>
                                                </div>
                                                <div class="mb-1">
                                                    <span class="text-muted d-sm-inline-block d-xs-block">Location:</span>
                                                    <span>{{ action.location }}</span>
                                                </div>
                                                <div class="mb-1">
                                                    <span class="text-muted d-sm-inline-block d-xs-block">Created By:</span>
                                                    <span><user-name :plainText="true" :user="creator(action)" /></span>
                                                </div>
                                                <div class="mb-1">
                                                    <span class="text-muted d-sm-inline-block d-xs-block">Assigned To:</span>
                                                    <span><user-name :plainText="true" :user="assignee(action)" /></span>
                                                </div>
                                            </div>
                                            <div class="col-6">
                                                <div class="mb-1">
                                                    <span class="text-muted d-sm-inline-block d-xs-block">Subcontractor:</span>
                                                    <span>{{ action.subcontractor }}</span>
                                                </div>
                                                <div class="mb-1">
                                                    <span class="text-muted d-sm-inline-block d-xs-block">Completed By:</span>
                                                    <span><user-name :plainText="true" :user="completer(action)" /></span>
                                                </div>
                                                <div class="mb-1">
                                                    <span class="text-muted d-sm-inline-block d-xs-block">Created Date:</span>
                                                    <span>{{ action.created_at_formatted }}</span>
                                                </div>
                                                <div class="mb-1">
                                                    <span class="text-muted d-sm-inline-block d-xs-block">Due Date:</span>
                                                    <span>{{ action.due_date | moment("MM/DD/YYYY") }}</span>
                                                </div>
                                                <div class="mb-1">
                                                    <span class="text-muted d-sm-inline-block d-xs-block">Completed Date:</span>
                                                    <span>{{ action.completed_at_formatted }}</span>
                                                </div>
                                                <div class="mb-1">
                                                    <span class="text-muted d-sm-inline-block d-xs-block">Time to Completion:</span>
                                                    <span>{{ action.time_to_completion }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <label class="text-muted">Details:</label><br>
                                        {{ action.detail }}<br/><br/>

                                        <label class="text-muted">Completed Notes:</label><br>
                                        {{ action.completed_detail }}<br/>

                                        <template v-if="action.files && action.files.length > 0">
                                            <hr/>
                                            <div class="row">
                                                <div v-for="file in action.files" class="col-4">
                                                    <img v-bind:src="file.full_thumbnail" class="img-fluid" />
                                                </div>
                                            </div>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </template>
            <p v-else>-- None --</p>

            <template v-if="showCompliant == 1">
                <h5 class="mt-4">{{ labelCompliant }} Items</h5>
                <div v-for="s in sectionCompliant" class="mt-4">
                    <h5><b>{{s['DisplayOrder']}}.0 {{s['SectionName']}}</b></h5>
                    <table class="table table-condensed table-bordered">
                        <tbody>
                            <template v-for="i in s['elements']">
                                <tr :key="'compliant-'+i.InspectionSectionId+'.'+i.DisplayOrder" class="break-protect">
                                    <td>{{s['DisplayOrder']}}.{{i.DisplayOrder}}</td>
                                    <td>{{ i.ElementText  }}</td>
                                    <td>
                                        <label class="text-success" v-if="i.ComplianceStatusId == 1">{{ labelCompliant }}</label>
                                        <label class="text-danger" v-if="i.ComplianceStatusId == 2">{{ labelNonCompliant }}</label>
                                        <label v-if="i.ComplianceStatusId == 3 || (undefined == i.ComplianceStatusId)">{{ labelNA }}</label>
                                    </td>
                                </tr>
                                <tr v-if="i.Comment || (i.files && i.files.length > 0)" :key="'compliant-comment-'+i.InspectionSectionId+'.'+i.DisplayOrder">
                                    <td colspan="3">
                                        <div v-if="i.Comment" class="mb-1"><b>Comment:</b> {{ i.Comment }}</div>

                                        <template v-if="i.files && i.files.length > 0">
                                            <hr v-if="i.Comment" />
                                            <div class="row">
                                                <div v-for="file in i.files" class="col-4">
                                                    <img v-bind:src="file.full_thumbnail" class="img-fluid" />
                                                </div>
                                            </div>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </template>

            <template v-if="files.length > 0">
                <h5 style="page-break-before: always;" class="mt-4">
                    Additional Files ({{ files.length }})
                    <button class="btn btn-sm btn-warning" title="PDFs are processing. Click here to refresh." v-on:click="reloadImages()" :disabled="imagesLoading" v-if="pdfs_proccessing">
                        <i class="fa fa-refresh" :class="{'fa-spin': imagesLoading}"></i> PDFs
                    </button>
                </h5>

                <div class="text-center mb-4" v-for="file in images">
                    <img v-bind:src="getThumbnail(file)" class="img-fluid" :ref="`file-${file.file_id}`">
                    <div class="text-muted small">
                        <strong class="project-attachment-filename" style="color: #333;">{{ file.file_name }}</strong><br/>
                        {{ file.created_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }} | {{ file.FirstName }} {{ file.LastName }}
                    </div>
                    <hr class="d-print-none" />
                </div>
            </template>
        </div>
    </div>
</div>
</template>

<script>
import moment from 'moment-timezone';

export default {
    data: function() {
        return {
            loading: true,
            InspectionId: this.$route.params.id,
            inspection: {},
            sections: [],
            safety_committee_members: [],
            showLogo: true,
            showCustomFields: true,
            showCompliant: 1,
            showNA: 1,
            showSafetyCommittee: 1,
            files: [],
            imagesLoading: false,
            pdfs_proccessing: false,
            result_labels: null,
            pdfLogo: null,
            custom_field_sections: [],
            personnel: [],
            enable_insp_scmm: null,
        }
    },

    watch: {
        showNA(newVal, oldVal){
            //For the re-draw
            this.$forceUpdate();
        },
    },

    computed: {
        owner() {
            return {
                FirstName: this.inspection.owner_first_name,
                LastName: this.inspection.owner_last_name,
                deleted_at: this.inspection.owner_deleted_at,
            };
        },

        superintendent() {
            return {
                FirstName: this.inspection.super_first_name,
                LastName: this.inspection.super_last_name,
                deleted_at: this.inspection.super_deleted_at,
            };
        },

        inspectionDateFormatted(){
            //Format the date
            return moment(this.inspection.InspectionDate, 'YYYY-MM-DD').format('MM/DD/YYYY');
        },

        canEditFiles(){
            //Check the user ID against the record id
            if(this.inspection.UserId == this.$store.state.user.UserId)
            {
                return true;
            }

            //Check manager permission
            if(this.$root.hasPermission('inspections.manage'))
            {
                return true;
            }

            //Default
            return false;
        },

        labelCompliant(){
            //Check if set
            if(this.result_labels && this.result_labels.compliant)
            {
                return this.result_labels.compliant;
            }

            //Default
            return 'Compliant';
        },

        labelNonCompliant(){
            //Check if set
            if(this.result_labels && this.result_labels.noncompliant)
            {
                return this.result_labels.noncompliant;
            }

            //Default
            return 'Non-Compliant';
        },

        labelNA(){
            //Check if set
            if(this.result_labels && this.result_labels.na)
            {
                return this.result_labels.na;
            }

            //Default
            return 'N/A';
        },

        sectionNonCompliant(){
            //Setup a local array
            var sections = [];

            //Loop
            for (var i = 0; i < this.sections.length; i++)
            {
                //Set a local help of has been added
                var sectionAdded = false;

                //Loop through the elements
                for (var j = 0; j < this.sections[i]['elements'].length; j++)
                {
                    //Check for compliance
                    if(this.sections[i]['elements'][j]['ComplianceStatusId'] == 2)
                    {
                        //Check if the section has been added
                        if(!sectionAdded)
                        {
                            //Build the formatted section
                            var formattedSection = {
                                CreatedBy: this.sections[i]['CreatedBy'],
                                Description: this.sections[i]['Description'],
                                DisplayOrder: this.sections[i]['DisplayOrder'],
                                InspectionSectionId: this.sections[i]['InspectionSectionId'],
                                IsActive: this.sections[i]['IsActive'],
                                ModifiedBy: this.sections[i]['ModifiedBy'],
                                SectionName: this.sections[i]['SectionName'],
                                SmartBizClientId: this.sections[i]['SmartBizClientId'],
                                created_at: this.sections[i]['created_at'],
                                elements: [],
                            };

                            //Push it onto the array
                            sections.push(formattedSection);

                            //Set the helper
                            sectionAdded = true;
                        }

                        //Push onto the array
                        sections[(sections.length - 1)]['elements'].push(this.sections[i]['elements'][j]);
                    }
                }
            }

            //Send it
            return sections;
        },

        sectionCompliant(){
            //Setup a local array
            var sections = [];

            //Loop
            for (var i = 0; i < this.sections.length; i++)
            {
                //Set a local help of has been added
                var sectionAdded = false;

                //Loop through the elements
                for (var j = 0; j < this.sections[i]['elements'].length; j++)
                {
                    //Check for compliance
                    if(this.sections[i]['elements'][j]['ComplianceStatusId'] != 2 && (this.showNA == 1 || this.sections[i]['elements'][j]['ComplianceStatusId'] == 1))
                    {
                        //Check if the section has been added
                        if(!sectionAdded)
                        {
                            //Build the formatted section
                            var formattedSection = {
                                CreatedBy: this.sections[i]['CreatedBy'],
                                Description: this.sections[i]['Description'],
                                DisplayOrder: this.sections[i]['DisplayOrder'],
                                InspectionSectionId: this.sections[i]['InspectionSectionId'],
                                IsActive: this.sections[i]['IsActive'],
                                ModifiedBy: this.sections[i]['ModifiedBy'],
                                SectionName: this.sections[i]['SectionName'],
                                SmartBizClientId: this.sections[i]['SmartBizClientId'],
                                created_at: this.sections[i]['created_at'],
                                elements: [],
                            };

                            //Push it onto the array
                            sections.push(formattedSection);

                            //Set the helper
                            sectionAdded = true;
                        }

                        //Push onto the array
                        sections[(sections.length - 1)]['elements'].push(this.sections[i]['elements'][j]);
                    }
                }
            }

            //Send it
            return sections;
        },

        images(){
            //Make sure we only pass images
            var types = ['jpg', 'jpeg', 'png', 'gif', 'tiff'];

            //Setup
            var imageFiles = [];

            //loop
            for(var i in this.files)
            {
                if(types.indexOf(this.files[i].file_extension.toLowerCase()) !== -1)
                {
                    imageFiles.push(this.files[i]);
                }
            }

            //Send it
            return imageFiles;
        },

        nonImages(){
            //Make sure we only pass images
            var types = ['jpg', 'jpeg', 'png', 'gif', 'tiff'];

            //Setup
            var files = [];

            //loop
            for(var i in this.files)
            {
                if(types.indexOf(this.files[i].file_extension.toLowerCase()) === -1)
                {
                    files.push(this.files[i]);
                }
            }

            //Send it
            return files;
        }
    },

    methods: {
        assignee(action) {
            return {
                FirstName: action.assignee_first_name,
                LastName: action.assignee_last_name,
                deleted_at: action.assignee_deleted_at,
            };
        },

        creator(action) {
            return {
                FirstName: action.creator_first_name,
                LastName: action.creator_last_name,
                deleted_at: action.creator_deleted_at,
            };
        },

        completer(action) {
            return {
                FirstName: action.completer_first_name,
                LastName: action.completer_last_name,
                deleted_at: action.completer_deleted_at,
            };
        },

        getInspection() {
            //Build the URL
            var url = '/inspections/view/' + this.InspectionId + '?pdf=true';

            //Check for Inspection GUID
            if(isNaN(this.InspectionId))
            {
                //Send it
                url = '/inspections/pdf-by-guid/' + this.InspectionId;
            }

            //Get the data
            this.$http
                .get(url)
                .then(response => {
                    //Set all the data
                    this.inspection = response.data.inspection;
                    this.sections = response.data.sections;
                    this.safety_committee_members = JSON.parse(this.inspection['safety_committee_members']);
                    this.files = response.data.files;
                    this.pdfs_proccessing = response.data.pdfs_proccessing;
                    this.pdfLogo = response.data.pdfLogo;
                    this.personnel = response.data.personnel;
                    this.enable_insp_scmm = response.data.enable_insp_scmm;

                    //Check for Result Labels
                    if(this.inspection.result_labels)
                    {
                        this.result_labels = JSON.parse(this.inspection.result_labels);
                    }

                    //Check for Result Labels
                    if(response.data.custom_field_sections)
                    {
                        //Set the Custom Fields
                        this.custom_field_sections = response.data.custom_field_sections;
                    }

                    //Set loading
                    this.loading = false;
                })
                .catch(response => {

                });
        },

        //Get the thumbnail preview
        getThumbnail(file){
            var preview = null;

            //Switch
            switch(file.file_extension)
            {
                case 'pdf':
                    preview = '/Images/file-type-pdf_256x256.png';
                    break;
                case 'docx':
                case 'doc':
                    preview = '/Images/file-type-docx_256x256.png';
                    break;
                case 'xls':
                case 'xlsx':
                    preview = '/Images/file-type-xlsx_256x256.png';
                    break;
                default:
                    //Data should be a path, not a string - we converted those
                    // $path = $this->{$imageDataName};
                    // $type = pathinfo($path, PATHINFO_EXTENSION);
                    // $data = Storage::get($path);
                    // $preview = "data:image/".$type.";base64," . base64_encode($data);
                    this.loadThumbnail(file);

                    //Stop here
                    return '';
                    break;
            }

            //Stop here
            return preview;

            //Set the preview
            //this.$refs['file-' + file.file_id][0].src = preview;
        },

        loadThumbnail(file){
            //Send it
            this.$http.get('files/view/'+file.file_id, {display_type: 'fluid'})
                .then(response => {
                    //Sent the ref
                    this.$refs['file-' + file.file_id][0].src = response.data;
                })
                .catch(err => {
                    switch(err.status)
                    {
                        case 410:
                            //Stop here?
                            //this.$refs['file-' + file.file_id][0].src = '/Images/file-not-found.png';
                            break;
                    }
                });
        },

        reloadImages(){
            //Reset the flag
            this.imagesLoading = true;

            //Send it
            this.$http
                .get('inspection/images/' + this.IncidentId)
                .then(response => {
                    //Set the data
                    this.files = response.data.images;
                    this.pdfs_proccessing = response.data.pdfs_proccessing;

                    //Alert
                    this.$toastr.success('Files & Photos Reloaded');
                })
                .catch(response => {

                })
                .then(() => {
                    //Reset the flag
                    this.imagesLoading = false;
                });
        }

    },
    mounted() {
        //Get the inspections
        this.getInspection();
    }
}
</script>
<style scoped>
.break-protect {
    page-break-inside: avoid;
}
</style>